export const ID_TYPE_DEFAULT_ISSUE_COUNTRY = {
  HKID: "Hong Kong",
  CNID: "China",
  "Travel Permit": "China",
  "MID No.": "Macau",
  "BR No.": "Hong Kong",
  "CI No.": "Hong Kong",
};

export const getDefaultIdIssueCountry = (idType) =>
  ID_TYPE_DEFAULT_ISSUE_COUNTRY[idType] ?? null;

export const isIdIssueCountryMissing = (value) =>
  value === null || value === undefined || !String(value).trim();

export const withDefaultIdIssueCountry = (values = {}) => {
  if (!isIdIssueCountryMissing(values.idIssueCountry)) return values;
  const country = getDefaultIdIssueCountry(values.idType);
  if (!country) return values;
  return { ...values, idIssueCountry: country };
};

export const applyDefaultIdIssueCountry = (idType, form) => {
  const country = getDefaultIdIssueCountry(idType);
  if (country) {
    form.setFieldValue("idIssueCountry", country);
  }
};
